import { PurchaseDetailClient } from './purchase-detail-client';

export const metadata = { title: 'Purchase Details | Alqove' };

export default function PurchaseDetailPage({ params }: { params: Promise<{ id: string }> }) {
  return <PurchaseDetailClient params={params} />;
}
